import { Component, OnInit } from '@angular/core';
import { PackageModel } from 'src/app/model/stripe-models/product/package-model';
import { getLocalStorageItem } from 'src/app/utils/browser-storage';

@Component({
    selector: 'app-payment-step-wrapper',
    templateUrl: './payment-step-wrapper.component.html',
    styleUrls: ['./payment-step-wrapper.component.scss'],
    standalone: false
})
export class PaymentStepWrapperComponent implements OnInit {

  package: PackageModel;

  constructor() { }

  ngOnInit(): void {
    const selectedPackage = getLocalStorageItem('selectedPackage-register');
    if (selectedPackage) {
      this.package = JSON.parse(selectedPackage);
    } else {
      // redirecte to tarif page?
    }
  }

}
